module.exports = __webpack_public_path__ + "img/hospitales.5ae6a840.jpg";